var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIdError = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0C20.816 0 0 20.816 0 46.5S20.816 93 46.5 93 93 72.184 93 46.5 72.184 0 46.5 0zm0 84.281c-20.834 0-37.781-16.949-37.781-37.781 0-20.832 16.947-37.781 37.781-37.781S84.281 25.668 84.281 46.5c0 20.832-16.947 37.781-37.781 37.781zm0-29.062a4.36 4.36 0 0 0 4.36-4.36V27.61a4.36 4.36 0 0 0-8.72 0v23.25a4.36 4.36 0 0 0 4.36 4.36zm0 6.012a5.712 5.712 0 0 0-5.71 5.71c.006 3.154 2.55 5.715 5.71 5.715s5.71-2.557 5.71-5.71c-.006-3.154-2.55-5.715-5.71-5.715z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIdError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/id-error.59c193b1.svg";
export { ForwardRef as ReactComponent };